import { generateSchema } from "decorator-form";
import { Component } from "react";
import * as React from "react";
import Form from "react-jsonschema-form";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import * as configActions from "core/actions/configActions";
import initialState from "core/reducers/initialState";
import PanelGeneralConfig from "./PanelGeneralConfig";

interface IPanelMetaFormStateProps {
	config: PanelGeneralConfig;
}

interface IPanelMetaFormDispatchProps {
	actions: typeof configActions;
}

interface IPanelMetaFormOwnProps {
	instance: string;
}

type ResultProps = IPanelMetaFormStateProps & IPanelMetaFormDispatchProps & IPanelMetaFormOwnProps;

class PanelMetaForm extends Component<ResultProps> {

	public render() {
		const { actions, config, instance } = this.props;

		return (
			<Form
				key={instance}
				{...generateSchema(PanelGeneralConfig)}
				formData={config || {}}
				onChange={(args) => actions.configPanelAdd(instance, args.formData)}
			>{" "}</Form>
		);
	}
}

function mapStateToProps(state: typeof initialState = initialState, { instance }: IPanelMetaFormOwnProps): IPanelMetaFormStateProps {
	return {
		config: state.config.panels[instance]
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IPanelMetaFormDispatchProps {
	return {
		actions: bindActionCreators<any>(configActions, dispatch)
	};
}

export default connect<IPanelMetaFormStateProps, IPanelMetaFormDispatchProps, IPanelMetaFormOwnProps>(mapStateToProps, mapDispatchToProps)(PanelMetaForm);



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelMetaForm.tsx